"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemsFooter = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var NavigationContext_1 = require("@qwilr/pages-common/src/Navigation/NavigationContext");
var react_transition_group_1 = require("react-transition-group");
var styles = __importStar(require("./MenuItemsFooter.css"));
var MenuItemsFooter = function (_a) {
    var items = _a.items;
    var _b = (0, NavigationContext_1.useNavigationContext)(), showHiddenItems = _b.showHiddenItems, setShowHiddenItems = _b.setShowHiddenItems;
    var shouldShowButton = !!items.find(function (item) { return !item.show; });
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: shouldShowButton, timeout: kaleidoscope_1.AnimationDuration.Short, mountOnEnter: true, unmountOnExit: true }, function (status) { return (react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
            setShowHiddenItems(!showHiddenItems);
        }, className: styles.button({ status: status }) }, showHiddenItems ? "Exclude hidden items" : "Include hidden items")); }));
};
exports.MenuItemsFooter = MenuItemsFooter;
